import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import { createCondition as __create_condition__ } from "babel-runtime-jsx-plus";
import React, { PureComponent } from 'react';
import { CnAsyncSelect, CnMessage } from '@alife/cn-ui';
import is from '@sindresorhus/is';
import { getPage } from "../../utils";
import "./pageSelectSetter.scss";
import { AppView, PageView, PAGE_STATUS } from "./c";
var selectStyle = {
  width: '250px'
};
export var PageSelectSetter = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(PageSelectSetter, _PureComponent);
  function PageSelectSetter(props) {
    var _this;
    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      schemaUrl: ''
    };
    _this.appMap = new Map();
    _this.pageMap = new Map();
    _this.versionMap = new Map();
    var value = _this.props.field.getValue() || {};
    if (is.plainObject(value)) {
      _this.state = _extends({}, _this.state, value);
    }
    return _this;
  }
  var _proto = PageSelectSetter.prototype;
  _proto.saveValue = function saveValue(update) {
    var fieldValue = this.props.field.getValue();
    Object.assign(fieldValue, update);
    // eslint-disable-next-line
    // @ts-ignore
    this.props.field.setValue(_extends({}, fieldValue));
    this.setState(update);
  };
  _proto.render = function render() {
    var _this2 = this;
    var state = this.state;
    var app = state.app,
      page = state.page,
      version = state.version;
    app = app || {
      appCode: ''
    };
    page = page || {
      id: '',
      pageTitle: '',
      pageRoute: ''
    };
    version = version || {
      pageVersion: '',
      status: 'EDITING'
    };
    var _ref = app || {},
      appCode = _ref.appCode;
    var appName = app.name || app.appName || '';
    var _ref2 = page || {},
      pageId = _ref2.id;
    var _ref3 = version || {},
      pageVersion = _ref3.pageVersion;
    var editorPage = getPage();
    var isConex = editorPage.isConex;
    var queryAppUrl = isConex ? "/nextapi/lowCodeApp/findByPage" : '/api/site/list?appOwnerType=all&appType2&extend1&isCoreApplications=-1&pageNum=1&pageSize=9999';
    var queryPageUrl = isConex ? '/nextapi/page/findByPage' : '/nextapi/page/querySitePage';
    var queryPageVersionUrl = isConex ? '/nextapi/page/findPageVersionList' : '/nextapi/page/version/pagingList';
    return /*#__PURE__*/React.createElement("div", {
      className: "page-select-setter"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "page-select-setter-title"
    }, "\u9009\u62E9\u5E94\u7528"), /*#__PURE__*/React.createElement(CnAsyncSelect, {
      disabled: true,
      showSearch: true,
      useVirtual: true,
      style: selectStyle,
      value: appCode,
      placeholder: "\u9009\u62E9\u5E94\u7528",
      remoteUrl: queryAppUrl,
      requestConfig: {
        throttleWait: 250,
        method: isConex ? 'POST' : 'GET',
        data: isConex ? {
          currentPage: 1,
          pageSize: 9999
        } : undefined,
        formatResult: function formatResult(res) {
          var r = res;
          var list = r.data.tableData || r.data.list || [];
          _this2.appMap = new Map();
          return list.map(function (item) {
            _this2.appMap.set(item.appCode || '', item);

            // 初始化
            if (!appName && item.appCode === appCode) {
              _this2.saveValue({
                app: item
              });
            }
            return {
              value: item.appCode,
              label: item.name || item.appName
            };
          });
        }
      },
      onChange: function onChange(value) {
        var item = _this2.appMap.get(value);
        if (!item) return;
        _this2.saveValue({
          app: item,
          page: undefined,
          version: undefined
        });
      }
    }), /*#__PURE__*/React.createElement(AppView, {
      app: app
    }), /*#__PURE__*/React.createElement("h4", {
      className: "page-select-setter-title"
    }, "\u9009\u62E9\u9875\u9762"), __create_condition__([[function () {
      return appCode;
    }, function () {
      return /*#__PURE__*/React.createElement(CnAsyncSelect, {
        showSearch: true,
        useVirtual: true,
        style: selectStyle,
        value: pageId,
        placeholder: "\u9009\u62E9\u9875\u9762",
        remoteUrl: queryPageUrl,
        requestConfig: {
          throttleWait: 250,
          method: 'POST',
          refreshDeps: [appCode],
          data: {
            appCode: appCode,
            currentPage: 1,
            pageSize: 9999
          },
          formatResult: function formatResult(res) {
            var r = res;
            _this2.pageMap = new Map();
            var url = new URL(location.href);
            var currPageId = url.searchParams.get('pageId');
            return r.data.tableData.filter(function (item) {
              // 过滤当前页面
              return item.id !== currPageId && (item.pageType === 6 || item.pageType === 7);
            }).map(function (item) {
              _this2.pageMap.set(item.id, item);
              return {
                value: item.id,
                label: item.pageTitle + " - " + item.pageRoute
              };
            });
          }
        },
        onChange: function onChange(value) {
          var item = _this2.pageMap.get(value);
          if (!item) return;
          _this2.saveValue({
            page: item,
            version: undefined
          });
        }
      });
    }], [function () {
      return true;
    }, function () {
      return /*#__PURE__*/React.createElement(CnMessage, {
        type: "notice"
      }, "\u8BF7\u5148\u9009\u62E9\u7AD9\u70B9");
    }]]), /*#__PURE__*/React.createElement("h4", {
      className: "page-select-setter-title"
    }, "\u9009\u62E9\u9875\u9762\u7248\u672C"), __create_condition__([[function () {
      return pageId;
    }, function () {
      return /*#__PURE__*/React.createElement(CnAsyncSelect, {
        showSearch: true,
        useVirtual: true,
        style: selectStyle
        // 不自动选择, 如果一个页面选中的时候是 dev 版本, 但是它发布到线上了, 那么选中的状态是不对的
        // value={pageVersion}
        ,
        placeholder: "\u9009\u62E9\u9875\u9762\u7248\u672C",
        remoteUrl: queryPageVersionUrl,
        requestConfig: {
          throttleWait: 250,
          method: 'POST',
          refreshDeps: [pageId],
          data: {
            sitePageId: pageId,
            currentPage: 1,
            pageSize: 9999
          },
          formatResult: function formatResult(res) {
            var r = res;
            _this2.versionMap = new Map();
            return r.data.tableData.map(function (item) {
              var _pageVersion = item.pageVersion,
                pageVersionDescription = item.pageVersionDescription,
                status = item.status;
              _this2.versionMap.set(_pageVersion, item);
              var label = _pageVersion;
              label += " - " + PAGE_STATUS[status];
              if (pageVersionDescription) {
                label += " - " + pageVersionDescription;
              }
              return {
                value: _pageVersion,
                label: label
              };
            });
          }
        },
        onChange: function onChange(value) {
          var item = _this2.versionMap.get(value);
          if (!item) return;
          _this2.saveValue({
            version: item
          });
        }
      });
    }], [function () {
      return true;
    }, function () {
      return /*#__PURE__*/React.createElement(CnMessage, {
        type: "notice"
      }, "\u8BF7\u5148\u9009\u62E9\u9875\u9762");
    }]]), /*#__PURE__*/React.createElement(PageView, {
      app: app,
      page: page,
      version: version
    }));
  };
  return PageSelectSetter;
}(PureComponent);